import BaseForm from '../base';
export class ManualDataEntryForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
